<template>
  <v-overlay
    class="splash-content"
    :model-value="modelValue"
    persistent
    :opacity="1"
    scrim="white"
    transition="fade-transition"
    z-index="9999"
  >
    <v-progress-circular
      class="splash-loader"
      indeterminate
      size="96"
      :color="BRAND_COLORS.primary"
    />
    <div class="splash-logo-container">
      <img
        alt="logo"
        title="Logo"
        class="splash-logo"
        src="@/assets/logo.svg"
        width="84"
        height="84"
      />
    </div>
  </v-overlay>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {BRAND_COLORS} from "@/plugins/vuetify.ts";

export default defineComponent({
  name: 'SplashScreen',
  computed: {
    BRAND_COLORS() {
      return BRAND_COLORS
    }
  },

  props: {
    modelValue: {
      type: Boolean,
      default: true
    }
  }
})
</script>

<style lang="scss" scoped>
.splash-content {
  :deep(.v-overlay__content) {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .splash-loader,
  .splash-logo-container {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .splash-logo-container {
    width: 84px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
